import React, { useContext } from 'react';

import { makeStyles } from '@material-ui/core';
import { PortalContext, getCiaFromUrl, api } from '@portal/arq-portal-core';

import { ListaProductos } from './ListaProductos'; 
import { Menu } from '@portal/arq-portal-core/dist/types/types';
import useSWR from 'swr';

const useStyles = makeStyles({
    productos: {
        //backgroundColor: '#ffffff',
        backgroundColor: '#f4f4f4',
        padding: '1.5rem',
        color: '#606060',
        fontFamily: 'CO-Bold',
        
        '& h3': {
            fontSize: '18px',
            marginBottom: '10px',
            paddingBottom: '15px',
            borderBottom: '1px solid #919191'
        }
    }
});

interface ProductosProps {
    cia?: string,
}

export const Productos = (props:ProductosProps) => {
    const clases = useStyles();
    const {menu, user} = useContext(PortalContext);
    const options = { focusThrottleInterval: 1000 * 3600 * 4, revalidateOnMount: true, revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false, dedupingInterval: 1000 * 3600 * 4 };
    const { data } = useSWR(["favoritos", user?.id], () => api.post("/be/favs", { Entrada: {} }), options);
    

    var enlaces: Menu | null = null;

    //Si especificamos una cia, buscamos los productos de esa cia
    if (props.cia){
        var found = false;
        menu?.enlaces?.forEach((item: Menu) => {
            if (item.origen && item.origen === props.cia && !found && item.url?.indexOf("producto") != -1){
                enlaces = item;
                found = true;
            }

            //Si los productos no estan en la raiz, buscamos en los hijos de /productos
            if(!found){
                item.enlaces?.forEach((item2: Menu) => {
                    if (item2.origen && item2.origen === props.cia && !found && item2.url?.indexOf("producto") != -1){
                        enlaces = item2;
                        found = true;
                    }
                });
            }
        });
    }else{
        if(menu && menu.enlaces){
            let index = menu.enlaces.findIndex((item: Menu) => item.url?.indexOf("producto") != -1)
            if (index != -1 && index != undefined){
                enlaces = menu.enlaces[index]; 
            }
        }
    }
    
    const cia = props.cia || getCiaFromUrl();

    return(
        <div className={clases.productos}>
            {menu?.enlaces &&
                <ListaProductos productos={enlaces?.enlaces} cia={cia} favs={data?.Salida?.Favoritos} />
            }
        </div>
    );
};